import React from "react";
import Button from '@mui/material/Button';
import { ValidateTankPhysicalInput } from "../ValidateTankPhysicalInput";
const btnsArray = [
  { buttonOperation: "Display" },
  { buttonOperation: "Change" },
  { buttonOperation: "Create" },
];

export default function OverviewButtons({
  tankPhysical,
  navigate,
  _getTankPhysicalExists,
  _createErrorMessage,
}) {
  const onClick = (buttonOperation, noValidation, navPath) => {
    let navigationUrl;
    if (buttonOperation === "Create") {
      navigationUrl = `/TankPhysical/Create`;
      navigate(navigationUrl);
      return;
    }

    let validationTankPhysicalResult = ValidateTankPhysicalInput(
      tankPhysical,
      _createErrorMessage
    );

    if (!validationTankPhysicalResult) {
      return;
    }

    _getTankPhysicalExists(
      { data: { Id: tankPhysical } },
      ({ data: isExist }) => {
        if (!isExist) {
          _createErrorMessage("111");
          return;
        }
        const navigationUrl = `/TankPhysical/${tankPhysical}/${buttonOperation}`;
        navigate(navigationUrl);
      }
    );
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ buttonOperation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }} key={i}>
          <Button
            className="btn btn-primary w-100"
            onClick={() => onClick(buttonOperation, noValidation, navPath)}
          >
            {buttonOperation}
          </Button>
        </div>
      ))}
    </div>
  );
}
